/** live: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "asking": "Asking the player for its screen…",
  "liveP2p": "Live · peer-to-peer, encrypted (DTLS-SRTP)",
  "noConnect": "Could not connect. The player’s network may block peer-to-peer traffic (a TURN relay is needed there).",
  "closed10": "Live view closed after 10 minutes to save the player’s bandwidth.",
  "endedReason": "The player ended the view: {reason}",
  "ended": "The player ended the view.",
  "stopped": "Stopped.",
  "leftPage": "Left the page.",
  "aSync": "Force sync",
  "aSyncHelp": "Fetch new content now",
  "aShot": "Capture screenshot",
  "aShotHelp": "Still of the screen",
  "aCache": "Clear cache",
  "aCacheHelp": "Free up space: remove media the player no longer needs",
  "aCacheQ": "Clear the cache? Media files the current content no longer uses are removed, along with saved web pages. What is on screen keeps playing; nothing needs downloading again.",
  "aBack": "Back",
  "aBackHelp": "Device Back button",
  "aBackTip": "Works over any app on rooted devices or with Displaro's accessibility switch on; otherwise only inside Displaro.",
  "aHome": "Home",
  "aHomeHelp": "Device home screen",
  "toastSent": "{action}: sent to the player",
  "toastDone": "{action}: done",
  "toastFailed": "{action}: {why}",
  "leaveTitle": "{action}: Displaro will leave the screen",
  "leaveBody": "Should Displaro come back to the screen by itself, or stay in the background until it's opened again (or you press Restart player)?",
  "leaveBack": "Come back in {s} seconds",
  "leaveStay": "Stay in the background",
  "aRecents": "Recent apps",
  "aRecentsHelp": "Switch apps, bring Displaro back",
  "aRecentsTip": "Needs root or Displaro's accessibility switch on the device.",
  "aRestart": "Restart player",
  "aRestartHelp": "Reopen the Displaro app",
  "aRestartQ": "Restart the player app? The screen goes black for a few seconds.",
  "aReboot": "Reboot player",
  "aRebootHelp": "Offline for 1–2 minutes",
  "aRebootTip": "Needs kiosk mode. Restart player works on every device.",
  "aRebootQ": "Reboot this player now? The screen goes dark while it restarts.",
  "delivered": "Delivered to the player — waiting for its result…",
  "checking": "… checking",
  "connected": "● Player connected (live channel)",
  "notConnected": "○ Player not connected",
  "reconnecting": "⚠ Reconnecting to the server…",
  "needOnline": "Commands and live view need the player online; nothing is queued.",
  "liveView": "Live view",
  "requires": "Requires {role}",
  "start": "▶ Start live view",
  "stop": "■ Stop",
  "liveOf": "Live view of the screen",
  "touchAria": "Touch the screen: click to tap, press and drag to swipe",
  "connecting": "Connecting…",
  "idle": "See exactly what the screen shows, in real time.",
  "liveBadge": "● LIVE",
  "touchHint": " · Click to tap, press and drag to swipe",
  "muted": "Muted. Closes automatically after 10 minutes.",
  "remoteActions": "Remote actions",
  "commandLog": "Command log",
  "thisSession": "(this session)",
  "noCommands": "No commands sent yet.",
  "screenshot": "Screenshot",
  "shotAlt": "Screenshot of the screen taken {at}",
  "download": "Download",
  "st_sending": "sending",
  "st_sent": "sent",
  "st_accepted": "accepted",
  "st_completed": "completed",
  "st_failed": "failed",
  "st_rejected": "rejected",
  "st_unsupported": "unsupported"
};
const ar: typeof en = {
  "asking": "جارٍ طلب شاشة المشغل…",
  "liveP2p": "مباشر · من نظير إلى نظير، مشفّر (DTLS-SRTP)",
  "noConnect": "تعذّر الاتصال. قد تحظر شبكة المشغل الاتصال من نظير إلى نظير (يلزم خادم ترحيل TURN هناك).",
  "closed10": "أُغلق العرض المباشر بعد ١٠ دقائق لتوفير نطاق المشغل.",
  "endedReason": "أنهى المشغل العرض: {reason}",
  "ended": "أنهى المشغل العرض.",
  "stopped": "توقف.",
  "leftPage": "غادرت الصفحة.",
  "aSync": "فرض المزامنة",
  "aSyncHelp": "اجلب المحتوى الجديد الآن",
  "aShot": "التقاط صورة للشاشة",
  "aShotHelp": "صورة ثابتة للشاشة",
  "aCache": "مسح الذاكرة المؤقتة",
  "aCacheHelp": "وفّر مساحة: احذف الوسائط التي لم يعد المشغّل يحتاجها",
  "aCacheQ": "مسح الذاكرة المؤقتة؟ تُحذف ملفات الوسائط التي لم يعد المحتوى الحالي يستخدمها، وكذلك صفحات الويب المحفوظة. يستمر عرض ما على الشاشة، ولا حاجة لإعادة تنزيل أي شيء.",
  "aBack": "رجوع",
  "aBackHelp": "زر الرجوع في الجهاز",
  "aBackTip": "يعمل فوق أي تطبيق على الأجهزة ذات صلاحيات الجذر أو عند تفعيل خيار إمكانية الوصول لـ Displaro؛ وإلا داخل Displaro فقط.",
  "aHome": "الشاشة الرئيسية",
  "aHomeHelp": "الشاشة الرئيسية للجهاز",
  "toastSent": "{action}: أُرسل إلى المشغّل",
  "toastDone": "{action}: تم",
  "toastFailed": "{action}: {why}",
  "leaveTitle": "{action}: سيغادر Displaro الشاشة",
  "leaveBody": "هل يعود Displaro إلى الشاشة تلقائيًا، أم يبقى في الخلفية حتى يُفتح مجددًا (أو تضغط إعادة تشغيل المشغّل)؟",
  "leaveBack": "العودة بعد {s} ثانية",
  "leaveStay": "البقاء في الخلفية",
  "aRecents": "التطبيقات الأخيرة",
  "aRecentsHelp": "بدّل التطبيقات وأعد Displaro",
  "aRecentsTip": "يحتاج صلاحيات الجذر أو خيار إمكانية الوصول لـ Displaro على الجهاز.",
  "aRestart": "إعادة تشغيل المشغّل",
  "aRestartHelp": "أعد فتح تطبيق Displaro",
  "aRestartQ": "إعادة تشغيل تطبيق المشغّل؟ ستصبح الشاشة سوداء لبضع ثوانٍ.",
  "aReboot": "إعادة تشغيل المشغل",
  "aRebootHelp": "غير متصل لدقيقة أو اثنتين",
  "aRebootTip": "يحتاج وضع الكشك. إعادة تشغيل المشغّل تعمل على كل الأجهزة.",
  "aRebootQ": "إعادة تشغيل هذا المشغل الآن؟ تصبح الشاشة مظلمة أثناء إعادة التشغيل.",
  "delivered": "وصل إلى المشغل — بانتظار النتيجة…",
  "checking": "… جارٍ التحقق",
  "connected": "● المشغل متصل (القناة المباشرة)",
  "notConnected": "○ المشغل غير متصل",
  "reconnecting": "⚠ جارٍ إعادة الاتصال بالخادم…",
  "needOnline": "تحتاج الأوامر والعرض المباشر إلى اتصال المشغل؛ لا يُحفظ شيء في قائمة انتظار.",
  "liveView": "العرض المباشر",
  "requires": "يتطلب {role}",
  "start": "▶ بدء العرض المباشر",
  "stop": "■ إيقاف",
  "liveOf": "عرض مباشر للشاشة",
  "touchAria": "المس الشاشة: انقر للمس، واضغط واسحب للتمرير",
  "connecting": "جارٍ الاتصال…",
  "idle": "شاهد ما تعرضه الشاشة بالضبط، مباشرة.",
  "liveBadge": "● مباشر",
  "touchHint": " · انقر للمس، واضغط واسحب للتمرير",
  "muted": "دون صوت. يُغلق تلقائيًا بعد ١٠ دقائق.",
  "remoteActions": "إجراءات عن بُعد",
  "commandLog": "سجل الأوامر",
  "thisSession": "(هذه الجلسة)",
  "noCommands": "لم تُرسل أوامر بعد.",
  "screenshot": "لقطة الشاشة",
  "shotAlt": "لقطة الشاشة الملتقطة {at}",
  "download": "تنزيل",
  "st_sending": "جارٍ الإرسال",
  "st_sent": "أُرسل",
  "st_accepted": "قُبل",
  "st_completed": "اكتمل",
  "st_failed": "فشل",
  "st_rejected": "رُفض",
  "st_unsupported": "غير مدعوم"
};
export default { en, ar };
